
/**
 * https://developerx.atlassian.net/browse/CS-5351
 *
 * Created at : 26 January 2022           Updated at : 26 January 2022
 * Created by : Risman Abdilah            Updated by : Risman Abdilah
 *
 * Version 2.3.0
 */

import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import directives from "@/directives";
import Component from "vue-class-component";

import ModalNewBroadcast from "./ModalNewBroadcast.vue";
import { Action, Mutation, State } from "vuex-class";
import { Prop, Watch } from "vue-property-decorator";
import { BroadcastModel } from "@/models/messaging.model";
import { isUniversity } from "@/functions/userinterface.function";
import toast from "@/functions/toast.function";

@Component({
  filters,
  directives,
  components: {
    ModalNewBroadcast,
  },
})
export default class BroadcastChat extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetMessagingBroadcast", { namespace: "messaging" })
  private actionGetMessagingBroadcast: any;
  @Action("actionGetCandidates", { namespace: "messaging" })
  private actionGetCandidates: any;

  /* STATE */
  @State("school", { namespace: "academy" })
  private school: any;
  @State("array_broadcast", { namespace: "messaging" })
  private array_broadcast: Array<BroadcastModel>;
  @State("detail_broadcast", { namespace: "messaging" })
  private detail_broadcast: BroadcastModel;

  /* MUTATIONS */
  @Mutation('setDetailBroadCast', { namespace: "messaging" })
  private setDetailBroadCast: any;

  /* INITIALIZATION */
  private showModal = false;

  private get school_id() {
    return this.school.id;
  }

  private get isBroadcastId() {
    return this.detail_broadcast.id !== 0;
  }

  private get isHighSchool() {
    if (isUniversity(this.school.school_type)) {
      return false;
    }

    return true;
  }

  @Watch("school_id", { deep: true, immediate: true })
  private onChangeSchoolId(val: any, oldVal: any) {
    this.getData();
  }

  @Prop({default: false})
  private canAccess: boolean;
  @Prop({default: false})
  private canSubscriptionAccess: boolean;
  @Prop({default: () => {}})
  private openModalPayment: () => {};

  @Watch("canSubscriptionAccess", { deep: true, immediate: true })
  private onChangeCanSubscriptionAccess(val: any, oldVal: any) {
    this.getData();
  }
  @Watch("canAccess", { deep: true, immediate: true })
  private onChangeAccess(val: any, oldVal: any) {
    this.getData();
  }

  // METHODS
  private getData() {
    if (this.school_id) {
      if (this.canAccess) {
        if (this.canSubscriptionAccess) {
          this.actionGetMessagingBroadcast({
            params: {
              school_id: this.school_id,
            },
          });
        }
      }
    }
  }
  private actionNewChat() {
    if (this.canAccess) {
      if (this.canSubscriptionAccess) {
        this.actionGetCandidates({
          params: {
            school_id: this.school_id,
            loader: false,
          },
        });
        this.showModal = true;
      } else {
        this.openModalPayment();
      }
    } else {
      toast.error(this.$i18n.t("feature_not_available"));
    }
  }

  private onClickChannel(item: BroadcastModel, index: number) {
    this.setDetailBroadCast(item);
    const width = $(window).width()
    if (width && width > 600) {
      $('.BroadcastChat .ChannelItem').removeClass('active');
      const channelItem = $(`.BroadcastChat #item${index}.ChannelItem`)
      channelItem.addClass('active')
    } else {
      $('.BroadcastChat .Channel').css({
        'display': 'none',
      })
      $('.BroadcastChat .ChannelDetail').css({
        'display': 'flex'
      })
      $('.BroadcastChat .ChannelDetail .back').css({
        'display': 'flex'
      })
    }
  }

  private actionBack() {
    this.setDetailBroadCast(new BroadcastModel());
    $('.BroadcastChat .ChannelDetail').css({
      'display': 'none'
    })
    $('.BroadcastChat .Channel').css({
      'display': 'block',
    })
  }

  private onSuccess() {
    this.actionGetMessagingBroadcast({
      params: {
        school_id: this.school_id,
      },
      success: () => {
        // Solution 1
        // window.location.reload();

        this.$emit("refresh");
      }
    });
  }
}
